import { CommonModule } from '@angular/common';
import { FilterTextComponent } from './filter-text.component';
import { FilterTextService } from './filter-text.service';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule],
  exports: [FilterTextComponent],
  declarations: [FilterTextComponent],
  providers: [FilterTextService]
})
export class FilterTextModule { }




// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/filter-text/filter-text.module.ts